import { IGa4ViewItem } from "../interfaces/ga4-event.interface";
import { ga4EventService } from "../services/ga4-event.service";
import { Ga4EcommerceComponent } from "./Ga4Ecommerce.component";

export class Ga4ViewItemEvent extends Ga4EcommerceComponent {
    constructor(protected element: HTMLElement) {
        super(element, 'Ga4ViewItemEvent');
    }
    protected fire() {
        // if its single/simple or config product
        const tcVars = window.tc_vars;
        if (!Array.isArray(tcVars.product_unitprice_ati) || tcVars.page_cat2 === 'config') {
            const value = Array.isArray(tcVars.product_unitprice_ati) ? tcVars.product_unitprice_ati[0] : tcVars.product_unitprice_ati;
            const viewItemEventData: IGa4ViewItem = {
                currency: window.tc_vars.product_currency,
                value: parseFloat(value),
                items: ga4EventService.getProductItems()
            };

            ga4EventService.viewItem(viewItemEventData);
        }
    }
}
